// ---------- initialize and render the React application in the browser ------------
// ----------------------------------------------------------------------------------

// load all of the necessary dependencies for the application
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import AlternativeData from './components/AlternativeData';
import BacktestingPage from './components/BacktestingPage';
import ResearchPage from './components/ResearchPage';
import { FullscreenProvider } from './contexts/FullscreenContext';
import './App.css';

// function to render the app with the router and the fullscreen provider
// full screen allows the user to view the charts and data in full screen mode - makes them more clear
function App() { 
  return (
    // wrap the whole app in the fullscreen provider so that the fullscreen context is available to all components
    <FullscreenProvider>  
      {/* wrap in a router so that the app can have multiple pages and the user can navigate between them */}
      <Router> 
        <div className="App"> 
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/alternative-data" element={<AlternativeData />} />
            <Route path="/backtesting" element={<BacktestingPage />} />
            <Route path="/research" element={<ResearchPage />} />
          </Routes>
        </div>
      </Router>
    </FullscreenProvider>
  );
}

export default App;
